// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabPoliticaDePrivacidad extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.politica_de_privacidad";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabPoliticaDePrivacidad {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Política de Privadesa",
                "cz": "Ochrana osobních údajů",
                "de": "Datenschutzrichtlinien",
                "es": "Política de Privacidad",
                "eu-ES": "Pribatutasun Politika",
                "fr": "Politique de Confidentialité",
                "fi": "Tietosuojakäytäntö",
                "ga-ES": "Política de Privacidade",
                "hi": "गोपनीयता नीति",
                "hu": "Adatvédelmi irányelvek",
                "it": "Politica sulla privacy",
                "nl": "Privacybeleid",
                "no": "Personvernerklæring",
                "pl": "Polityka prywatności",
                "pt-BR": "Política de privacidade",
                "pt-PT": "Política de privacidade",
                "ro": "Politica de confidențialitate",
                "ru": "Политика конфиденциальности",
                "sv": "Integritetspolicy",
                "sk": "Zásady ochrany osobných údajov"
            },
            "defecto": "Privacy Policy"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
